<script>

export default {
    props: {
        time: {
            type: Number,
            default: 15,
        },
        resize: {
            type: Boolean,
            default: false,
        },
        createdTime: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            timerInterval: null,
            timeLeft: Number,
            remainingPathColor: "base-timer__path-remaining-green",
            circleDasharray: 283,
            now: new Date()

        };
    },
    mounted() {
        this.startTimer()
    },
    watch: {
        createdTime: function() {
            this.startTimer()
        }
    },
    methods: {
        onTimesUp() {
            clearInterval(this.timerInterval);
        },
        startTimer() {
            const createdTimeDate = new Date (this.createdTime)
            const timeDifference = Math.abs(this.now - createdTimeDate)
            const differenceMinutes = Math.floor(timeDifference / 60000);

            if(!this.time || differenceMinutes > this.time) {
                this.timeLeft = 0
                this.remainingPathColor = "base-timer__path-remaining-grey"
                this.circleDasharray = 283
            } else {
                this.timeLeft = this.time - differenceMinutes
                let timePassed= differenceMinutes
                const timeLimit = this.time
                this.setRemainingPathColor(this.timeLeft);
                this.setCircleDasharray();
                this.timerInterval = setInterval(() => {
                    timePassed = timePassed += 1;
                    this.timeLeft = timeLimit - timePassed;
                    this.setRemainingPathColor(this.timeLeft);
                    this.setCircleDasharray();
                    if (this.timeLeft === 0) {
                        this.onTimesUp();
                    }
                }, 60000);
            }
        },

        setRemainingPathColor(timeLeft) {
            const warningTime = 10
            const alertTime = 5
            const colorCodes = {
                info: "base-timer__path-remaining-green",
                warning: "base-timer__path-remaining-orange",
                alert:"base-timer__path-remaining-red",
                stop: "base-timer__path-remaining-grey",
            }
            if (timeLeft == 0) {
                this.remainingPathColor = colorCodes.stop
            }
             else if (timeLeft <= alertTime) {
                this.remainingPathColor = colorCodes.alert
            } else if (timeLeft <= warningTime) {
                this.remainingPathColor = colorCodes.warning
            }
        },

        calculateTimeFraction() {
            const timeLimit = this.time
            const rawTimeFraction = this.timeLeft / timeLimit;
            return rawTimeFraction - (1 / timeLimit) * (1 - rawTimeFraction);
        },

        setCircleDasharray() {
            const full_dash_array = 283
            this.circleDasharray = `${(
                this.calculateTimeFraction() * full_dash_array
            ).toFixed(0)} 283`;
        }
    },
}
</script>

<template>
    <div class="base-timer" :class="resize ? 'base-timer-resize' : ''">
        <svg class="base-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <g class="base-timer__circle">
            <circle class="base-timer__path-elapsed" cx="50" cy="50" r="45"></circle>
            <path
                class="base-timer__path-remaining"
                :class="remainingPathColor"
                :stroke-dasharray= "circleDasharray"
                d="
                M 50, 50
                m -45, 0
                a 45,45 0 1,0 90,0
                a 45,45 0 1,0 -90,0
                "
            ></path>
            </g>
        </svg>
        <span id="base-timer-label" class="base-timer__label">{{ timeLeft }}´</span>
        </div>
</template>

<style lang="scss" scoped>
@import "@/design/settings";
@import '@/design/views/popup/countDown';
</style>
